import { render, staticRenderFns } from "./BatchDeliver.vue?vue&type=template&id=f1335b30&scoped=true"
import script from "./BatchDeliver.vue?vue&type=script&lang=js"
export * from "./BatchDeliver.vue?vue&type=script&lang=js"
import style0 from "./BatchDeliver.vue?vue&type=style&index=0&id=f1335b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1335b30",
  null
  
)

export default component.exports